import api from './api';

export interface Task {
  id: number;
  case_id: number;
  case_number?: string;
  client_name?: string;
  title: string;
  description?: string;
  type: 'drafting' | 'filing' | 'research' | 'meeting' | 'court' | 'other';
  priority: 'low' | 'normal' | 'high' | 'urgent';
  status: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  assigned_to?: number;
  assigned_to_name?: string;
  due_date?: string;
  completed_at?: string;
  semaphore: 'green' | 'yellow' | 'red';
  created_by: number;
  created_at?: string;
  updated_at?: string;
}

export interface TaskListParams {
  page?: number;
  limit?: number;
  status?: string;
  priority?: string;
  assigned_to?: number;
  case_id?: number;
  semaphore?: string;
}

export interface CreateTaskDto {
  case_id: number;
  title: string;
  description?: string;
  type?: string;
  priority?: string;
  assigned_to?: number;
  due_date?: string;
}

const tasksService = {
  async list(params?: TaskListParams) {
    const response = await api.get('/tasks', { params });
    return {
      data: response.data.data || [],
      pagination: response.data.meta || { page: 1, limit: 20, total: 0, totalPages: 1 }
    };
  },

  async getById(id: number): Promise<Task> {
    const response = await api.get(`/tasks/${id}`);
    return response.data.data || response.data;
  },

  async getByCase(caseId: number): Promise<Task[]> {
    const response = await api.get(`/tasks/case/${caseId}`);
    return response.data.data || [];
  },

  async getMyTasks(): Promise<Task[]> {
    const response = await api.get('/tasks/my');
    return response.data.data || [];
  },

  async create(data: CreateTaskDto): Promise<Task> {
    const response = await api.post('/tasks', data);
    return response.data.data || response.data;
  },

  async update(id: number, data: Partial<CreateTaskDto>): Promise<Task> {
    const response = await api.patch(`/tasks/${id}`, data);
    return response.data.data || response.data;
  },

  async complete(id: number): Promise<Task> {
    const response = await api.post(`/tasks/${id}/complete`);
    return response.data.data || response.data;
  },

  async cancel(id: number): Promise<Task> {
    const response = await api.post(`/tasks/${id}/cancel`);
    return response.data.data || response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/tasks/${id}`);
  }
};

export default tasksService;
